import axios from 'axios';
import API_CONFIG from '../config';

const api = axios.create({
  baseURL: '',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
api.interceptors.response.use(
  (response) => response.data,
  (error) => {
    const errorMessage = error.response?.data?.message || 
                        error.message || 
                        'An error occurred';
    
    // Handle 401 - Unauthorized
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    
    return Promise.reject(errorMessage);
  }
);

// API Service
const ApiService = {
  // Products
  getProducts: (params) => api.get(API_CONFIG.ENDPOINTS.PRODUCTS, { params }),
  getProduct: (id) => api.get(API_CONFIG.ENDPOINTS.PRODUCT_BY_ID(id)),
  
  // Auth
  login: (data) => api.post(API_CONFIG.ENDPOINTS.AUTH_LOGIN, data),
  register: (data) => api.post(API_CONFIG.ENDPOINTS.AUTH_REGISTER, data),
  getProfile: () => api.get(API_CONFIG.ENDPOINTS.AUTH_ME),
  
  // Cart
  getCart: () => api.get(API_CONFIG.ENDPOINTS.CART),
  addToCart: (data) => api.post(API_CONFIG.ENDPOINTS.CART_ADD, data),
  updateCartItem: (id, data) => api.put(API_CONFIG.ENDPOINTS.CART_ITEM(id), data),
  removeCartItem: (id) => api.delete(API_CONFIG.ENDPOINTS.CART_ITEM(id)),
  
  // Orders
  createOrder: (data) => api.post(API_CONFIG.ENDPOINTS.ORDERS, data),
  getOrders: () => api.get(API_CONFIG.ENDPOINTS.MY_ORDERS),

  // Subscription
  subscribe: (data) => api.post(API_CONFIG.ENDPOINTS.SUBSCRIBE, data),
  sendNotificationToSubscribers: (message) =>
    api.post(API_CONFIG.ENDPOINTS.SUBSCRIBE_NOTIFY, { message }),
  
  // Health
  healthCheck: () => api.get(API_CONFIG.ENDPOINTS.HEALTH)
};

export default ApiService;